/**
 * BarChart de placements agrupados por tipo (ad_type o outlet_kind o state).
 * Usa Recharts BarChart con colores de la paleta del proyecto.
 */
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const PALETTE = ["#2563EB", "#10B981", "#F97316", "#EF4444", "#8B5CF6", "#06B6D4", "#F59E0B", "#EC4899"];

export interface MediaChartByTypeProps {
  title: string;
  data: Record<string, number>;
  labels?: Record<string, string>;  // mapping clave → label legible
  height?: number;
  emptyText?: string;
}

export function MediaChartByType({
  title, data, labels = {}, height = 260, emptyText = "Sin datos",
}: MediaChartByTypeProps) {
  const entries = Object.entries(data).sort((a, b) => b[1] - a[1]);
  const chartData = entries.map(([key, value]) => ({
    key,
    label: labels[key] ?? key,
    value,
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm font-semibold">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        {!chartData.length ? (
          <div className="text-center py-8 text-xs text-ink-400">{emptyText}</div>
        ) : (
          <ResponsiveContainer width="100%" height={height}>
            <BarChart data={chartData} margin={{ top: 10, right: 10, bottom: 30, left: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
              <XAxis
                dataKey="label"
                tick={{ fontSize: 11 }}
                angle={-30}
                textAnchor="end"
                height={60}
                interval={0}
              />
              <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
              <Tooltip
                contentStyle={{
                  backgroundColor: "white",
                  border: "1px solid #E5E7EB",
                  borderRadius: 6,
                  fontSize: 12,
                }}
                cursor={{ fill: "rgba(37,99,235,0.05)" }}
              />
              <Bar dataKey="value" radius={[4, 4, 0, 0]}>
                {chartData.map((_, i) => (
                  <Cell key={i} fill={PALETTE[i % PALETTE.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
